import React from "react";
import AllCategoriesFive from "./CategoryModule/AllCategoriesFive";

const CategoriesFive = () => {
  return (
    <div>
      <AllCategoriesFive />
    </div>
  );
};

export default CategoriesFive;
